import { NativeEvent } from '../NativeEvent';

export class BiometricAvailabilityEvent extends NativeEvent<
  'biometricAvailability',
  Record<string, never>
> {
  readonly type = 'biometricAvailability';
  readonly payload: Record<string, never> = {};
}
